import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { KonkurrencePlacering } from './KonkurrencePlacering';
import { OpgaveDelopgavePlacering } from '../../models/OpgaveDelopgavePlacering';

export interface ScoreboardRowProps {
    samletPlacering: number;
    holdnavn: string;
    institution: string;
    opgaveDelopgavePlaceringer: OpgaveDelopgavePlacering[];
    sortedColumnName: string;
    bootstrapCols: number;
    showSamletPlacering: boolean;
    samletAntalPoint: number;
}

export default class ScoreboardRow extends React.Component<ScoreboardRowProps, any> {
    renderCol(text: string, colName: string) {
        let className = '';
        if (this.props.sortedColumnName === colName) {
            className = 'sorted-by';
        }

        return (
            <h2 className={className}>
                {text}
            </h2>
        );
    }

    render() {
        const resultatCols = this.props.opgaveDelopgavePlaceringer.map((placering, c) =>
            (
                <Col key={c} md={this.props.bootstrapCols} centerText={true}>
                    {placering.antalPoint % 1 === 0 ? this.renderCol(placering.antalPoint.toString(), placering.id) : this.renderCol(placering.antalPoint.toFixed(2).replace('.', ','), placering.id)}
                </Col>
            )
        );

        const konkurrencePlacering = this.props.showSamletPlacering ? (<KonkurrencePlacering placering={this.props.samletPlacering} />) : undefined;
        const konkurrenceSamletPoint = this.props.showSamletPlacering ? (
            <div className='scoreboard-samlet-point'>{this.props.samletAntalPoint % 1 === 0 ? this.props.samletAntalPoint : this.props.samletAntalPoint.toFixed(2).replace('.', ',')}
            </div>) : undefined;

        return (
            <Row className='resultat-row'>
                <Col md={1} centerText={true}>
                    {konkurrencePlacering}
                    {konkurrenceSamletPoint}
                </Col>
                <Col md={2} className='holdnavn'>
                    <h2>{this.props.holdnavn}</h2>
                </Col>
                <Col md={2} className='institutionsnavn'>
                    <h2>{this.props.institution} </h2>
                </Col>
                {resultatCols}
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Scoreboard/ScoreboardRow.tsx